import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class NewDiscussionInTagNotification extends Notification {
  icon() {
    return 'fas fa-user-tag';
  }

  href() {
    return app.route.discussion(this.attrs.notification.subject());
  }

  content() {
    const notification = this.attrs.notification;
    const subject = notification.subject();
    const tagName = notification.attribute('subjectTagName');
    const title = subject ? subject.title() : '';
    const displayTitle = tagName ? `${title} [${tagName}]` : title;
    return app.translator.trans('florcarioca-rsvp.forum.notifications.new_discussion_in_tag_text', {
      user: notification.fromUser(),
      discussion_title: displayTitle,
    });
  }

  excerpt() {
    return null;
  }
}
